import React from 'react';

const DateRegistrationStats = ({ dateStatsData, isLoading }) => {
  return (
    <div className="mt-10">
      <div className="mb-4">
        <h3 className="text-base font-medium text-gray-50">
          Inscriptions établissements / organisations
        </h3>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg p-4 md:p-6">
        {isLoading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-6 animate-pulse">
            {[1, 2, 3, 4].map((index) => (
              <div key={index} className="min-w-0">
                <div className="h-4 bg-teal-10/80 rounded mb-3 w-20"></div>
                <div className="flex flex-wrap items-center gap-2">
                  <div className="h-3 bg-teal-10/80 rounded w-24"></div>
                  <div className="h-3 bg-teal-10/80 rounded w-12"></div>
                </div>
              </div>
            ))}
          </div>
        ) : dateStatsData ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-6">
            {dateStatsData.dates.map((item, index) => (
              <div key={index} className="min-w-0">
                <h4 className="text-base font-semibold text-gray-50 mb-3">{item.date}</h4>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-sm text-gray-50">Total personnes</span>
                  <span className="text-base font-medium text-blue-10">
                    {item.people.toLocaleString('fr-CH')}
                  </span>
                </div>
              </div>
            ))}
            <div className="min-w-0">
              <h4 className="text-base font-semibold text-teal-40 mb-3">Total</h4>
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-sm text-gray-50">Total personnes</span>
                <span className="text-base font-medium text-teal-40">
                  {dateStatsData.total.people.toLocaleString('fr-CH')}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-2">Aucune donnée disponible</div>
        )}
      </div>
    </div>
  );
};

export default DateRegistrationStats;
